(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }
      // CRO 2026-09 t6: Shopify's availability errors quote the tracked quantity, and no supplier's quantity
      // is a real stock count, so a count-free message replaces them (same rule as theme.js quantityChanged).
      if (/\d/.test(String(message)) && /availab|in your cart|can only add|only \d/i.test(String(message))) {
        message = "Sorry, we can't add that many of this item right now. For a larger order, please get in touch.";
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.popover"] && !Shopify.designMode) return;
  try {
    class KitPopover extends HTMLElement {
    #abortController = null;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      // Prevent flash of previously-positioned popover
      this.addEventListener(
        'beforetoggle',
        (event) => {
          if (event.newState === 'open') {
            this.style.visibility = 'hidden';
          }
        },
        { signal }
      );

      this.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') {
            this.#position();
            this.style.visibility = '';
          }
        },
        { signal }
      );

      window.addEventListener(
        'resize',
        () => {
          if (this.matches(':popover-open')) this.#position();
        },
        { signal, passive: true }
      );

      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('a[href], button:not([popovertarget])')) {
            this.hidePopover();
          }
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #position() {
      const trigger = document.querySelector(`[popovertarget="${this.id}"]`);
      if (!trigger) return;

      const placement = this.getAttribute('placement') || 'bottom-start';
      const isRTL = getComputedStyle(this).direction === 'rtl';
      const gap = Number(this.getAttribute('gap') ?? 4);
      const margin = 4;

      const triggerRect = trigger.getBoundingClientRect();
      const popoverWidth = this.offsetWidth;
      const popoverHeight = this.offsetHeight;

      const [axis, alignment] = placement.split('-');

      let top = axis === 'bottom' ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap;
      let resolvedAxis = axis;

      // Auto-flip vertically if overflowing viewport
      if (axis === 'bottom' && top + popoverHeight > window.innerHeight - margin) {
        top = triggerRect.top - popoverHeight - gap;
        resolvedAxis = 'top';
      } else if (axis === 'top' && top < margin) {
        top = triggerRect.bottom + gap;
        resolvedAxis = 'bottom';
      }

      const alignStart = isRTL ? 'end' : 'start';
      let left;
      if (alignment === 'center') {
        left = triggerRect.left + (triggerRect.width - popoverWidth) / 2;
      } else if (alignment === alignStart) {
        left = triggerRect.left;
      } else {
        left = triggerRect.right - popoverWidth;
      }

      // Clamp horizontally to viewport
      if (left < margin) {
        left = margin;
      } else if (left + popoverWidth > window.innerWidth - margin) {
        left = window.innerWidth - popoverWidth - margin;
      }

      this.style.transformOrigin = resolvedAxis === 'bottom' ? 'top' : 'bottom';

      // Convert to document coordinates so popover scrolls with page
      this.style.top = `${Math.round(top + window.scrollY)}px`;
      this.style.left = `${Math.round(left + window.scrollX)}px`;
    }
  }

  customElements.define('kit-popover', KitPopover);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      // Apex fix (2026-08-27): a fresh controller per setup. The constructor's
      // controller is one-shot — after inView's exit callback aborts it, a
      // re-entry re-added the scroll listener with an already-aborted signal
      // (a spec-defined no-op), leaving the scroller dead after one deep
      // scroll past the section and back.
      this.abortController = new AbortController()
      this.resizeObserver.observe(this)
      // Apex fix (2026-08-27b): the sticky top depends on --header-height,
      // which theme.js sets AFTER this element first measures itself — the
      // stale value then persists via the inline style. Re-read once the
      // page has fully loaded, and track the header's own size changes
      // (stuck-state padding, responsive shifts) through the same observer.
      const siteHeader = document.querySelector('.site-header')
      if (siteHeader) this.resizeObserver.observe(siteHeader)
      if (document.readyState !== 'complete') {
        window.addEventListener('load', () => this.recalculateStyles(), { once: true, signal: this.abortController.signal })
      }
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      // Apex fix (2026-08-27): sync the integrator to the real scroll
      // position. A fresh instance started at lastKnownScrollY = 0, so a
      // (re)construction mid-page (variant-change hot-reload, scroll
      // restoration) fed a phantom -scrollY delta into currentTop and
      // snapped taller-than-viewport content to its bottom-pinned state.
      this.lastKnownScrollY = window.scrollY
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
      // APEX-SWAP-LOCK: while a switch is in flight no add may start from this form (see apexSwapBegin below). Capture
      // on this ancestor runs before the form's own listeners (ProductForm), so a blocked submit never reaches them.
      this.addEventListener('submit', (event) => {
        if (!this.apexSwapLocked) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
    }

    // APEX-SWAP-LOCK-START (7 Oct 2026; launch-audit/publish-readiness/fixtures/swap-lock-2026-10-07/)
    // ProductForm (snippets/form.product.liquid) awaits /cart.js before it reads `new FormData(this.form)`, and it fires
    // its events on its own <product-form>. A swap below replaces that element. An add started just before or during a
    // swap therefore read the DETACHED old form (the variant shown before the switch: the shopper picked Mesh and got
    // Upholstered), and its 'product-form:cart:navigate' never reached the document listener that cancels it, so Impulse
    // went to /cart. A click during the view transition or before Globo's replay refilled the required fields was lost
    // while the button looked ready. So: from the shopper's own change until the newest swap has landed and Globo's
    // replay has finished, Add to Cart is disabled (the sticky bar mirrors `disabled`) and any submit from this form is
    // blocked; an add already running is let finish before the form is replaced; only the newest switch swaps.
    apexSwapBegin() {
      this.apexSwapSeq = (this.apexSwapSeq || 0) + 1;
      this.apexSwapLocked = true;
      this.apexLockButtons();
      return this.apexSwapSeq;
    }

    apexSwapEnd(seq) {
      if (seq !== this.apexSwapSeq || !this.apexSwapLocked) return;
      this.apexSwapLocked = false;
      this.querySelectorAll('[data-apex-swap-lock]').forEach((button) => {
        // A button whose own add is still running stays disabled: ProductForm re-enables it in its finally.
        if (!button.classList.contains('product-form__submit-button--pulsing')) {
          button.disabled = button.getAttribute('data-apex-swap-lock') === 'disabled';
        }
        button.removeAttribute('data-apex-swap-lock');
        button.removeAttribute('aria-busy');
      });
      // apex-your-chair.liquid writes the configured total onto the button only while it is enabled, and refreshes on
      // any 'change': let it run now. This element is not a variant input, so onVariantChange ignores the event.
      this.dispatchEvent(new Event('change', { bubbles: true }));
    }

    apexRevertInputs() {
      // A switch that could not be applied (the section fetch failed or timed out): put the option inputs back to what
      // the section on the page was rendered with, which is the variant in its form, so what the shopper sees is what
      // Add to Cart adds. 'change' is re-fired on each input put back (the custom dropdown relabels itself on it, Globo
      // re-reads the variant); apexReverting stops onVariantChange from treating that as a new switch.
      this.apexReverting = true;
      try {
        this.querySelectorAll('[data-product-hot-reload-trigger]').forEach((input) => {
          if (input.tagName === 'SELECT') {
            const rendered = Array.from(input.options).find((option) => option.defaultSelected) || input.options[0];
            if (rendered && input.value !== rendered.value) {
              input.value = rendered.value;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else if (input.checked !== input.defaultChecked) {
            input.checked = input.defaultChecked;
            if (input.checked) input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      } finally {
        this.apexReverting = false;
      }
    }

    apexLockButtons() {
      if (!this.apexSwapLocked) return;
      this.querySelectorAll('form[action*="/cart/add"] [type="submit"]').forEach((button) => {
        // Remember the state to restore: a sold-out button stays disabled; one disabled only by ProductForm's own
        // running add (it re-enables it itself) counts as enabled.
        if (!button.hasAttribute('data-apex-swap-lock')) {
          const own = button.disabled && !button.classList.contains('product-form__submit-button--pulsing');
          button.setAttribute('data-apex-swap-lock', own ? 'disabled' : 'enabled');
        }
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      });
    }

    apexAddSettled() {
      // ProductForm marks its button --pulsing for the whole add and clears it in its finally. Capped at 10 s.
      const started = Date.now();
      return new Promise((resolve) => {
        const check = () => {
          if (!this.querySelector('.product-form__submit-button--pulsing') || Date.now() - started > 10000) {
            this.apexLockButtons(); // ProductForm's finally re-enabled the old button; it is still mid-switch
            resolve();
          } else {
            setTimeout(check, 50);
          }
        };
        check();
      });
    }
    // APEX-SWAP-LOCK-END

    showLoadingState() {
      // Apex (swap lock): a second switch must not orphan the first timer, or the pulse sticks after both swaps end.
      if (this.loadingTimeout) clearTimeout(this.loadingTimeout);
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option (a failed prefetch is retried by the switch itself)
      this.fetchContent(requestUrl).catch(() => {});
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      // APEX-SWAP-LOCK: give up after 15 s (Add to Cart stays locked while a switch is pending) and never cache a
      // failed response (a 429/503 page would otherwise be served for this option until the page is reloaded).
      const signal = window.AbortSignal && AbortSignal.timeout ? AbortSignal.timeout(15000) : undefined;
      const fetchPromise = fetch(requestUrl, { signal })
        .then((response) => {
          if (!response.ok) throw new Error('Section request failed: HTTP ' + response.status);
          return response.text();
        })
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;
      if (this.apexReverting) return; // APEX-SWAP-LOCK: the revert of a failed switch, not a new one

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Apex (Session 55): remember the customer's Globo picks before the swap destroys the app.
      let apexGpoSnap = null;
      try { apexGpoSnap = window.apexGpoSnapshot ? window.apexGpoSnapshot(this) : null; } catch (e) {}
      // APEX-SWAP-LOCK: once an earlier switch has replaced the Globo app, the app here is half rebuilt (defaults) until
      // that switch's replay ends, so carry the picks that replay is restoring instead of reading the defaults.
      const apexPending = this.apexGpoPending;
      if (apexPending && this.querySelector('.gpo-app') !== apexPending.app) apexGpoSnap = apexPending.snap;
      this.apexGpoPending = apexGpoSnap ? { snap: apexGpoSnap, app: apexPending ? apexPending.app : this.querySelector('.gpo-app') } : null;
      // CRO 2026-09 F27 (S61 C-200, released by the founder as D12, 24 Sep 2026): remember the customer's own assembly
      // tick too. The swap below replaces the delivery block with an unticked box. Same product only.
      let apexWgSnap = null;
      try { apexWgSnap = (window.apexWgSnapshot && newProductUrl === oldProductUrl) ? window.apexWgSnapshot(this) : null; } catch (e) {}

      // APEX-SWAP-LOCK: lock Add to Cart still in the shopper's own change task (nothing above awaits); only this
      // newest switch may swap.
      const apexSeq = this.apexSwapBegin();

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;
      let apexSwapped = false;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        // APEX-SWAP-LOCK: a newer switch owns the swap (this content is stale); an add already running finishes first.
        if (apexSeq !== this.apexSwapSeq) return;
        if (!html || !html.getElementById(this.id)) throw new Error('Section ' + this.id + ' missing from the response');
        await this.apexAddSettled();
        if (apexSeq !== this.apexSwapSeq) return;
        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
        apexSwapped = true;
        // CRO 2026-09 F27 / D12: tick the new box again when the new variant offers the same assembly tier.
        try { if (apexWgSnap && window.apexWgRestore) window.apexWgRestore(this, apexWgSnap); } catch (e) {}
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // APEX-SWAP-LOCK: only the newest switch finishes the swap; it unlocks once Globo's replay is done (capped).
        if (apexSeq === this.apexSwapSeq) {
          // Always hide loading state
          this.hideLoadingState();
          // APEX-SWAP-LOCK: the switch failed (fetch error or timeout, or a page without this section): forget that
          // response and put the inputs back to the variant the form holds before unlocking.
          if (!apexSwapped) {
            this.cache.delete(requestUrl);
            try { this.apexRevertInputs(); } catch (e) {}
          }
          let apexReleased = false;
          const apexRelease = () => {
            if (apexReleased) return;
            apexReleased = true;
            if (apexSeq === this.apexSwapSeq) this.apexGpoPending = null;
            this.apexSwapEnd(apexSeq);
          };
          // Arm the replay before Globo rebuilds, so its gpoRenderCompleted event is not missed.
          try {
            if (apexGpoSnap && window.apexGpoReplay) {
              window.apexGpoReplay(this, apexGpoSnap, apexRelease);
              setTimeout(apexRelease, 2500);
            } else {
              apexRelease();
            }
          } catch (e) { apexRelease(); }
          GPOConfigs?.initialize?.();
        }
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
          this.apexLockButtons(); // APEX-SWAP-LOCK: the new button arrives locked, before it is painted
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
        this.apexLockButtons(); // APEX-SWAP-LOCK
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      // APEX-SWAP-DRAWER: not while a drawer is open (an add made just before this switch opened the cart drawer, which
      // holds the focus); the option sits behind the drawer's overlay, out of reach of keyboard and screen-reader users.
      if (!document.documentElement.classList.contains('js-drawer-open')) this.querySelector(`#${targetId}`).focus();
    }
  }

  // APEX-GPO-REPLAY-START (Session 55, 2026-09-11; price resync added CRO 2026-09 finding A, 24 Sep 2026)
  // A variant switch replaces this element's innerHTML, which destroys the Globo app mounted inside it; Globo
  // then rebuilds from defaults, so every add-on the customer picked silently returned to £0 — even between
  // variants showing identical options. Snapshot the picks before the swap and re-apply them after Globo's
  // re-render, by element id (name + value as fallback). Only when the same option set comes back: a switch
  // to a variant with a different set still resets, as intended. click() is used for checkboxes and radios so
  // Globo's own handlers run (conditions, prices); a few passes let conditional fields appear before filling.
  // PRICE RESYNC: for every field whose condition reads the Shopify variant, Globo re-fires 'change' on the
  // field's DEFAULT input 300 ms after its render (setTimeout(…, 300) in its conditional logic). That late event
  // lands after the replay; for a radio, Globo then keeps the replayed value but takes the price from the (now
  // unchecked) default, so the hidden input loses its price, "Selections will add" drops and the add-on goes to
  // the cart at £0. After Globo's late event, re-fire 'change' on any replayed input whose hidden input no longer
  // carries its price, so Globo's own handler recomputes the price, the total and _gpo_addon_products.
  window.apexGpoSnapshot = function (root) {
    const app = root.querySelector('.gpo-app');
    if (!app) return null;
    const items = [];
    app.querySelectorAll('input, select, textarea').forEach((el) => {
      const t = (el.type || el.tagName || '').toLowerCase();
      if (!el.id && !el.name) return;
      if (t === 'hidden' || t === 'file' || t === 'submit' || t === 'button') return;
      // APEX-GPO-CARRY: field (data-field-name) and on (enabled = its field was visible) feed carry() below.
      if (t === 'checkbox' || t === 'radio') items.push({ id: el.id, name: el.name, value: el.value, type: t, checked: el.checked, field: el.getAttribute('data-field-name') || '', on: !el.disabled });
      else items.push({ id: el.id, name: el.name, value: el.value, type: t });
    });
    return { set: app.getAttribute('data-option-set-id'), items };
  };
  // onDone (APEX-SWAP-LOCK): called once the passes have stopped (nothing left to change, or the fourth pass).
  window.apexGpoReplay = function (root, snap, onDone) {
    const done = () => { try { if (onDone) onDone(); } catch (e) {} };
    if (!snap || !snap.items || !snap.items.length) { done(); return; }
    const find = (app, it) => {
      let el = it.id ? app.querySelector('#' + CSS.escape(it.id)) : null;
      if (!el && it.name) {
        const byValue = it.type === 'checkbox' || it.type === 'radio' ? '[value="' + CSS.escape(it.value) + '"]' : '';
        el = app.querySelector('[name="' + CSS.escape(it.name) + '"]' + byValue);
      }
      return el;
    };
    // APEX-GPO-CARRY-START (14 Oct 2026, Toleo Telegrey route T; launch-audit/ads-2026-10-14/day/telegrey-package/).
    // Globo set 1702982 (Toleo, Toleo Pro, Toleo Move) builds "Shell & base colour" and "5-star base" once per fabric
    // group, because the "Telegrey shell, telegrey base" price differs per group (39/36/38/37/36/37). A fabric-group
    // switch hides the old group's copy (Globo disables its inputs), so find() returns a disabled input and the new
    // group's copy kept its default: a Telegrey chair silently became black. For a pick that was CHECKED in a VISIBLE
    // copy of an allow-listed field, use the one enabled copy whose field name differs only in the group number, with
    // the identical value. That copy's own Globo price applies (Group 1 +39 -> Group 2 +36); no Globo set, price or
    // cart label changes. Any other set or field, or not exactly one match: resolve() returns what find() returns.
    const CARRY = { '1702982': [/^Shell & base colour \(Group \d\)$/, /^Base \(Group \d \u2014 (?:black|telegrey) base\)$/] };
    const groupless = (f) => f.replace(/\(Group \d/, '(Group #');
    const carry = (app, it) => {
      const rules = CARRY[snap.set];
      if (!rules || it.type !== 'radio' || !it.checked || !it.on || !it.field) return null;
      const rule = rules.find((re) => re.test(it.field));
      if (!rule) return null;
      const want = groupless(it.field);
      const hits = Array.from(app.querySelectorAll('input[type="radio"]')).filter((x) => {
        const f = x.getAttribute('data-field-name') || '';
        return !x.disabled && x.value === it.value && f !== it.field && rule.test(f) && groupless(f) === want;
      });
      return hits.length === 1 ? hits[0] : null;
    };
    const resolve = (app, it) => {
      const el = find(app, it);
      if (el && !el.disabled) return el;
      return carry(app, it) || el;
    };
    // APEX-GPO-CARRY-END
    const liveApp = () => {
      const app = root.querySelector('.gpo-app');
      if (!app) return null;
      if (snap.set && app.getAttribute('data-option-set-id') !== snap.set) return null;
      return app;
    };
    const pass = () => {
      const app = liveApp();
      if (!app) return 0;
      let changed = 0;
      snap.items.forEach((it) => {
        const el = resolve(app, it);
        if (!el || el.disabled) return;
        if (it.type === 'checkbox' || it.type === 'radio') {
          if (el.checked !== it.checked && (it.checked || it.type === 'checkbox')) { el.click(); changed++; }
        } else if (el.value !== it.value) {
          el.value = it.value;
          el.dispatchEvent(new Event('input', { bubbles: true }));
          el.dispatchEvent(new Event('change', { bubbles: true }));
          changed++;
        }
      });
      return changed;
    };
    const resync = () => {
      const app = liveApp();
      if (!app) return 0;
      const hidden = Array.from(document.querySelectorAll('.gpo-hidden-inputs [data-field-name]'));
      let fixed = 0;
      snap.items.forEach((it) => {
        if (!it.checked || (it.type !== 'checkbox' && it.type !== 'radio')) return;
        const el = resolve(app, it);
        if (!el || el.disabled || !el.checked) return;
        const price = el.getAttribute('data-addon-price');
        if (!(parseFloat(price) > 0)) return;
        const field = el.getAttribute('data-field-name');
        const h = hidden.find((x) => x.getAttribute('data-field-name') === field);
        if (!h || h.disabled) return;
        if ((h.getAttribute('data-addon-price') || '').split(',').indexOf(price) !== -1) return;
        el.dispatchEvent(new Event('change', { bubbles: true }));
        fixed++;
      });
      return fixed;
    };
    let runs = 0;
    const run = () => { runs++; if (pass() > 0 && runs < 4) setTimeout(run, 150); else done(); };
    let started = false;
    const start = () => {
      if (started) return;
      started = true;
      setTimeout(run, 50);
      [450, 1000, 2000].forEach((ms) => setTimeout(resync, ms));
    };
    document.addEventListener('gpoRenderCompleted', start, { once: true });
    setTimeout(start, 1500);
  };
  // APEX-GPO-PRICE-GUARD (P1, 7 Oct 2026; launch-audit/publish-readiness/fixtures/globo-p1-2026-10-07/). About 285 ms
  // after each re-render Globo fires a late 'change' on a field's unchecked DEFAULT radio and takes the price from that
  // target, which strips the price from the shopper's picked add-on (hidden input and _gpo_addon_products). Impulse
  // builds the add (new FormData) only after awaiting /cart.js, so an Add to Cart in that gap carted the add-on at £0.
  // The timers above repair it at R+450; this guard makes the stripped state unreadable by the add:
  //  (a) in Globo's own late dispatch: a capture listener sees the 'change' on an UNCHECKED radio in .gpo-app and adds
  //      a once-listener to that target, which runs after Globo's own handler in the same dispatch and repairs there;
  //  (b) at the payload: product-form:submit:before is dispatched in the same task as Impulse's new FormData, with that
  //      FormData as detail.form; if anything had to be repaired, Globo's corrected values are copied into it.
  // The repair (resyncNow) is DOM-driven, not snapshot-driven: every checked, enabled choice with data-addon-price > 0
  // whose field's enabled hidden input lacks that price gets 'change' re-fired, so Globo's own handler restores the
  // hidden input and _gpo_addon_products. It never checks, unchecks, adds or waits. window.apexGpoGuard: switches, counters.
  (function () {
    if (window.apexGpoGuard) return;
    const G = (window.apexGpoGuard = { on: { a: true, b: true }, stats: { a: 0, b: 0, sent: 0, refused: 0 } });
    const SENT_MAX = 200; // hook (a) stops after this many re-fired changes in one page view; (b) and the timers never do
    let busy = false;
    const carries = (list, price) => String(list || '').split(',').some((x) => Math.abs(parseFloat(x) - price) < 0.005);
    const hiddenFor = (wrap, field) => {
      const all = wrap.querySelectorAll('[data-field-name]');
      for (let i = 0; i < all.length; i++) if (all[i].getAttribute('data-field-name') === field) return all[i];
      return null;
    };
    const resyncNow = function () {
      if (busy) return 0;
      busy = true;
      let fixed = 0;
      try {
        document.querySelectorAll('.gpo-app').forEach((app) => {
          const form = app.closest('form');
          const wrap = (form && form.querySelector('.gpo-hidden-inputs')) || document.querySelector('.gpo-hidden-inputs');
          if (!wrap) return;
          app.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach((el) => {
            if (el.disabled) return;
            const price = parseFloat(el.getAttribute('data-addon-price'));
            if (!(price > 0)) return;
            const field = el.getAttribute('data-field-name');
            const h = field ? hiddenFor(wrap, field) : null;
            if (!h || h.disabled || carries(h.getAttribute('data-addon-price'), price)) return;
            G.stats.sent++;
            el.dispatchEvent(new Event('change', { bubbles: true }));
            const h2 = hiddenFor(wrap, field);
            if (h2 && !h2.disabled && carries(h2.getAttribute('data-addon-price'), price)) fixed++;
            else G.stats.refused++;
          });
        });
      } catch (e) {}
      busy = false;
      return fixed;
    };
    window.apexGpoResyncNow = resyncNow;
    // (a) Globo's late event does not bubble and is handled on the input itself. A capture listener on document runs
    // before the target phase, so a once-listener added to the target now runs after Globo's (registered at render).
    // A 'change' on an UNCHECKED radio is never the shopper's own: theirs always targets the input they just checked.
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (busy || !G.on.a || G.stats.sent >= SENT_MAX) return;
      if (!(t instanceof HTMLInputElement) || t.type !== 'radio' || t.checked || !t.closest('.gpo-app')) return;
      t.addEventListener('change', () => { G.stats.a += resyncNow(); }, { once: true });
    }, true);
    // (b) The payload moment (snippets/form.product.liquid: "allows modification of formData"). Capture on document, so
    // it runs before any listener on the product form. Covers a mouse click, Enter/Space and the sticky bar's .click().
    // If a repair was needed, the Globo keys of the FormData already built are replaced in place, in their order.
    document.addEventListener('product-form:submit:before', (e) => {
      if (!G.on.b) return;
      try {
        const fd = e.detail && e.detail.form;
        const host = e.target;
        const form = host && (host.form instanceof HTMLFormElement ? host.form : host.querySelector && host.querySelector('form'));
        const wrap = form && form.querySelector('.gpo-hidden-inputs');
        if (!wrap || !(fd instanceof FormData)) return;
        const fixed = resyncNow();
        G.stats.b += fixed;
        if (!fixed) return;
        const fresh = new FormData(form);
        const names = new Set();
        wrap.querySelectorAll('[name]').forEach((i) => names.add(i.name));
        fd.forEach((v, k) => { if (k.indexOf('properties[_gpo') === 0) names.add(k); });
        const out = [];
        const done = new Set();
        Array.from(fd.entries()).forEach(([k, v]) => {
          if (!names.has(k)) { out.push([k, v]); return; }
          if (done.has(k)) return;
          done.add(k);
          fresh.getAll(k).forEach((x) => out.push([k, x]));
        });
        names.forEach((k) => { if (!done.has(k)) fresh.getAll(k).forEach((x) => out.push([k, x])); });
        Array.from(new Set(fd.keys())).forEach((k) => fd.delete(k));
        out.forEach(([k, v]) => fd.append(k, v));
      } catch (err) {}
    }, true);
  })();
  // APEX-GPO-REPLAY-END
  // APEX-WG-RESTORE-START (CRO 2026-09, finding F27 colour half; S61 C-200 released by the founder as D12)
  // A variant switch replaces this element's innerHTML, so the assembly box rendered by
  // snippets/section.flex-pdp.delivery-tier.liquid comes back unticked and the customer's choice is dropped. Snapshot
  // the tick before the swap; after it, tick the new box with click() so the block's own delegated 'change' listener
  // writes the free tier's property again (the paid tier is read at add time, as before). Only a box the customer
  // ticked in this page is restored, and only when the new variant offers the SAME tier (same data-wg-included,
  // data-wg-paid-variant and data-wg-prop-name). Otherwise the box stays unticked: no property, no charge.
  window.apexWgSnapshot = function (root) {
    const block = root.querySelector('[data-wg]');
    const cb = block && block.querySelector('[data-wg-checkbox]');
    if (!cb || !cb.checked) return null;
    return {
      included: block.getAttribute('data-wg-included') || '',
      paid: block.getAttribute('data-wg-paid-variant') || '',
      prop: block.getAttribute('data-wg-prop-name') || ''
    };
  };
  window.apexWgRestore = function (root, snap) {
    if (!snap) return false;
    const block = root.querySelector('[data-wg]');
    const cb = block && block.querySelector('[data-wg-checkbox]');
    if (!cb || cb.checked || cb.disabled) return false;
    if ((block.getAttribute('data-wg-included') || '') !== snap.included) return false;
    if ((block.getAttribute('data-wg-paid-variant') || '') !== snap.paid) return false;
    if ((block.getAttribute('data-wg-prop-name') || '') !== snap.prop) return false;
    cb.click();
    return cb.checked;
  };
  // APEX-WG-RESTORE-END
  // APEX-SWAP-DRAWER-START (8 Oct 2026; launch-audit/publish-readiness/fixtures/swap-drawer-2026-10-08/)
  // An Add to Cart pressed just before a variant switch opens the cart drawer (the swap waits for that add, see
  // apexAddSettled). Then the swap lands and the replay above re-ticks the shopper's Globo picks with el.click(), and
  // apexWgRestore re-ticks White Glove with cb.click(). Each of those clicks bubbles to window, where an open Impulse
  // drawer treats any click outside itself as "close" (theme.js, theme.Drawers bindEvents). So the drawer shut by itself
  // about 450 ms after it opened, and the shopper saw nothing of the chair that had gone in. A click the page makes on
  // these inputs (isTrusted false) is never the shopper's: while a drawer is open, stop it at window, before the
  // drawer's listener (added at each open, so after this one) sees it. The click's path is read with composedPath(),
  // which is fixed when the dispatch starts, so a Globo handler that re-renders the input cannot hide where it came
  // from. The shopper's own clicks and every listener below window (Globo's own, the replay's) are untouched.
  // window.apexSwapDrawer: switch and counter.
  (function () {
    if (window.apexSwapDrawer) return;
    const D = (window.apexSwapDrawer = { on: true, kept: 0 });
    window.addEventListener('click', (e) => {
      if (!D.on || e.isTrusted || !document.documentElement.classList.contains('js-drawer-open')) return;
      let picks = false;
      let ours = false;
      for (const node of e.composedPath()) {
        if (!(node instanceof Element)) continue;
        if (!picks && node.matches('.gpo-app, [data-wg]')) picks = true;
        if (node.localName === 'product-hot-reload') { ours = picks; break; }
      }
      if (!ours) return;
      e.stopImmediatePropagation();
      D.kept++;
    });
  })();
  // APEX-SWAP-DRAWER-END

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.gift-recipient"] && !Shopify.designMode) return;
  try {
    class GiftRecipientForm extends HTMLElement {
    constructor() {
      super()
      this.checkboxInput = this.querySelector('.gift-recipient-form__checkbox input[type="checkbox"]')
      this.emailInput = this.querySelector('.gift-recipient-form__email')
      this.nameInput = this.querySelector('.gift-recipient-form__name')
      this.messageInput = this.querySelector('.gift-recipient-form__message')
      this.dateInput = this.querySelector('.gift-recipient-form__date')
      this.addEventListener('change', () => this.onChange())
      this.recipientFields = this.querySelector('.recipient-fields')

      this.checkboxInput.addEventListener('change', () => {
        event.stopPropagation()
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none'
      })
    }

    connectedCallback() {
      this.abortController = new AbortController()

      document.addEventListener('product-form:submit:error', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.displayErrorMessage(event.detail.errorMessage)
        }
      }, { signal: this.abortController.signal })

      document.addEventListener('product-form:submit:success', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.clearInputFields()
          this.clearErrorMessage()
        }
      }, { signal: this.abortController.signal })
    }

    disconnectedCallback() {
      this.abortController.abort()
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields()
        this.clearErrorMessage()
      }
    }

    clearInputFields() {
      for (const element of this.querySelectorAll('input')) {
        element.value = ''
      }
    }

    displayErrorMessage(body) {
      this.clearErrorMessage()
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`]
          if (!inputElement) {
            return
          }

          inputElement.setAttribute('aria-invalid', true)
        })
      }
    }

    clearErrorMessage() {
      for (const inputElement of this.querySelectorAll('input')) {
        inputElement.setAttribute('aria-invalid', false)
        inputElement.removeAttribute('aria-describedby')
      }
    }
  }

  customElements.define('gift-recipient-form', GiftRecipientForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryElement extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.media-gallery__slide');
      this.thumbs = this.querySelectorAll('.media-gallery__thumb');
      this.prevBtn = this.querySelector('.media-gallery__nav--prev');
      this.nextBtn = this.querySelector('.media-gallery__nav--next');
      this.mainContainer = this.querySelector('.media-gallery__main');
      this.currentIndex = 0;
      this.isAnimating = false;
      this.isNaturalAspectRatio = this.mainContainer?.getAttribute('data-aspect-ratio') === 'initial';

      // Touch/swipe handling
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.minSwipeDistance = 50;
      this.isThumbnailTouch = false;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Adjust container height for natural aspect ratio
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight(true); // Disable transition for initial setup

        // Set up resize observer for images that might load asynchronously
        this.setupResizeObserver();
      }

      // Add click handlers to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const direction = index > this.currentIndex ? 'next' : 'prev';
          this.goToSlide(index, direction);
        });
      });

      // Add click handlers to navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.previousSlide();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.nextSlide();
        });
      }

      // Add keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      });

      // Make the gallery focusable for keyboard navigation
      this.setAttribute('tabindex', '0');

      // Add touch/swipe handlers
      this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
      this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });

      // Ensure only the initial active slide can play
      this.pauseNonActiveSlides();
      this.autoplayActiveSlideIfEligible();
    }

    goToSlide(index, direction = 'next') {
      if (index < 0 || index >= this.slides.length) return;
      if (index === this.currentIndex) return;
      if (this.isAnimating) return;

      const currentSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[index];

      // Before animating, pause non-target slides
      this.pauseAllMediaExceptInSlide(targetSlide);

      // Reset all slides
      this.resetSlides();

      // Position slides for animation
      this.positionSlidesForAnimation(currentSlide, targetSlide, direction);

      // Update UI state
      this.updateThumbnails(index);
      this.currentIndex = index;

      // Start animation after positioning is applied
      this.animateSlides(currentSlide, targetSlide, direction);

      // Adjust container height for natural aspect ratio after slide change
      if (this.isNaturalAspectRatio) {
        setTimeout(() => {
          this.adjustContainerHeight();
        }, 50); // Small delay to ensure slide is positioned
      }
    }

    resetSlides() {
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next');
      });
    }

    positionSlidesForAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class from all slides during positioning
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--is-animating');
      });

      if (direction === 'next') {
        // Next: target and others on right, current stays in center
        targetSlide.style.transform = 'translateX(100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(100%)';
          }
        });
      } else {
        // Previous: target and others on left, current stays in center
        targetSlide.style.transform = 'translateX(-100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(-100%)';
          }
        });
      }
    }

    updateThumbnails(activeIndex) {
      this.thumbs[this.currentIndex].classList.remove('media-gallery__thumb--active');
      this.thumbs[activeIndex].classList.add('media-gallery__thumb--active');
    }

    adjustContainerHeight(disableTransition = false) {
      if (!this.isNaturalAspectRatio || !this.mainContainer) return;

      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      // Disable transition if requested (for initial setup)
      if (disableTransition) {
        this.mainContainer.classList.add('media-gallery__main--no-transition');
      }

      // Find the image in the active slide
      const img = activeSlide.querySelector('img');
      if (!img) return;

      // Get the image's natural dimensions
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;

      if (imgWidth && imgHeight) {
        // Calculate the aspect ratio
        const aspectRatio = imgWidth / imgHeight;

        // Get the container width
        const containerWidth = this.mainContainer.offsetWidth;

        // Calculate the height based on the aspect ratio
        const calculatedHeight = containerWidth / aspectRatio;

        // Set the container height
        this.mainContainer.style.height = calculatedHeight + 'px';
      } else {
        // Fallback: temporarily make the slide visible to measure its height
        const originalOpacity = activeSlide.style.opacity;
        const originalTransform = activeSlide.style.transform;
        activeSlide.style.opacity = '1';
        activeSlide.style.transform = 'translateX(0)';
        activeSlide.style.position = 'relative';
        activeSlide.style.visibility = 'hidden';

        // Get the natural height of the slide content
        const slideHeight = activeSlide.offsetHeight;

        // Restore original styles
        activeSlide.style.opacity = originalOpacity;
        activeSlide.style.transform = originalTransform;
        activeSlide.style.position = '';
        activeSlide.style.visibility = '';

        // Set the container height to match the slide height
        this.mainContainer.style.height = slideHeight + 'px';
      }

      // Re-enable transition after a brief delay
      if (disableTransition) {
        setTimeout(() => {
          this.mainContainer.classList.remove('media-gallery__main--no-transition');
        }, 10);
      }
    }

    setupResizeObserver() {
      if (!this.isNaturalAspectRatio || !window.ResizeObserver) return;

      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContainerHeight();
      });

      // Observe all images in the slides
      this.slides.forEach(slide => {
        const images = slide.querySelectorAll('img');
        images.forEach(img => {
          this.resizeObserver.observe(img);

          // Also listen for load events to recalculate when image loads
          img.addEventListener('load', () => {
            if (slide.classList.contains('media-gallery__slide--active')) {
              this.adjustContainerHeight();
            }
          });
        });
      });
    }

    animateSlides(currentSlide, targetSlide, direction) {
      // Set animation flag
      this.isAnimating = true;

      // Frame 1: Initial positions are already set (no animation class)

      // Frame 2: Add animation class
      requestAnimationFrame(() => {
        currentSlide.classList.add('media-gallery__slide--is-animating');
        targetSlide.classList.add('media-gallery__slide--is-animating');

        // Frame 3: Trigger animation
        requestAnimationFrame(() => {
          // Animate current slide out
          if (direction === 'next') {
            currentSlide.style.transform = 'translateX(-100%)';
          } else {
            currentSlide.style.transform = 'translateX(100%)';
          }

          // Animate target slide in
          targetSlide.style.transform = 'translateX(0)';
          targetSlide.classList.add('media-gallery__slide--active');

          // Clean up after animation. isAnimating is released in a finally so
          // that a throw anywhere in the cleanup can't strand the flag at true —
          // goToSlide() early-returns while it is set, so a stranded flag kills
          // every subsequent arrow, keyboard and thumbnail navigation with no
          // recovery short of a page reload.
          this.waitForTransition(currentSlide).then(() => {
            try {
              this.positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction);
              this.scrollActiveThumbnailIntoView();
              // Hydrate and autoplay current slide media if eligible and pause others
              this.pauseNonActiveSlides();
              this.autoplayActiveSlideIfEligible();
            } finally {
              this.isAnimating = false;
            }
          });
        });
      });
    }

    positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class and active class from current slide
      currentSlide.classList.remove('media-gallery__slide--is-animating', 'media-gallery__slide--active');
      targetSlide.classList.remove('media-gallery__slide--is-animating');

      if (direction === 'next') {
        currentSlide.style.transform = 'translateX(100%)';
      } else {
        currentSlide.style.transform = 'translateX(-100%)';
      }

      // Adjust container height for natural aspect ratio after animation
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight();
      }
    }

    scrollActiveThumbnailIntoView() {
      this.thumbs[this.currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex, 'next');
    }

    previousSlide() {
      const prevIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goToSlide(prevIndex, 'prev');
    }

    // Resolves when the element's transition finishes — but never DEPENDS on
    // that happening. Waiting on `transitionend` alone is a liveness hazard: if
    // no transition actually runs, the event never fires, the promise never
    // settles, and animateSlides()'s cleanup never executes. That leaves
    // isAnimating pinned true (all navigation dead) and two slides both holding
    // --active (a visible artifact), with no recovery short of a reload.
    //
    // Reproduced 2026-08-03 in a real foregrounded browser by suppressing
    // transitions the way an animation-blocking extension, a userstyle or an
    // accessibility/kiosk stylesheet does:
    //   * { transition: none !important }
    // -> first next() jams the gallery permanently.
    //
    // So: race the event against a deadline derived from the element's OWN
    // computed transition duration, rather than a hardcoded number that would
    // silently desync if the 0.3s in the stylesheet above ever changes. When no
    // transition is in effect the computed duration is 0 and we resolve on the
    // next tick — instant and correct for someone who has opted out of motion.
    waitForTransition(element) {
      return new Promise((resolve) => {
        let settled = false;
        let timer = null;

        const finish = () => {
          if (settled) return;
          settled = true;
          element.removeEventListener('transitionend', handleTransitionEnd);
          clearTimeout(timer);
          resolve();
        };

        const handleTransitionEnd = (e) => {
          // Children transition too (images, the lightbox trigger); only the
          // slide's own transition marks the end of the slide animation.
          if (e.target === element) finish();
        };

        element.addEventListener('transitionend', handleTransitionEnd);
        timer = setTimeout(finish, this.transitionTimeout(element));
      });
    }

    // Longest (duration + delay) across the element's transitioned properties,
    // in ms, plus a small margin so the event normally wins the race and the
    // fallback stays a backstop rather than a truncation of the animation.
    transitionTimeout(element) {
      const toMs = (value) => {
        const v = (value || '').trim();
        if (!v) return 0;
        const n = parseFloat(v);
        if (Number.isNaN(n)) return 0;
        return v.endsWith('ms') ? n : n * 1000;
      };

      let longest = 0;
      try {
        const styles = getComputedStyle(element);
        const durations = (styles.transitionDuration || '0s').split(',');
        const delays = (styles.transitionDelay || '0s').split(',');
        durations.forEach((duration, i) => {
          const total = toMs(duration) + toMs(delays[i] !== undefined ? delays[i] : delays[0]);
          if (total > longest) longest = total;
        });
      } catch (e) {
        longest = 0;
      }

      return longest > 0 ? longest + 120 : 0;
    }

    handleTouchStart(e) {
      if (this.isAnimating) return;

      // Touches that begin on the thumbnail strip belong to the strip's own
      // native horizontal scrolling. Without this guard a swipe on the strip
      // ALSO advanced the main gallery one slide, whose slide-change handler
      // then re-centred the strip on the new active thumb — so the strip
      // "snapped back" and could never be browsed freely (founder,
      // 2026-07-17). Tapping a thumbnail still works via its click handler.
      this.isThumbnailTouch = !!e.target.closest('.media-gallery__thumbnails');
      if (this.isThumbnailTouch) return;

      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
      // Reset end coords so a plain tap can't inherit the previous gesture's
      // delta and register as a phantom swipe.
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchMove(e) {
      if (this.isAnimating || this.isThumbnailTouch) return;

      const touch = e.touches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchEnd(e) {
      if (this.isAnimating || this.isThumbnailTouch) return;

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // Only trigger swipe if horizontal movement is greater than vertical
      if (absDeltaX > absDeltaY && absDeltaX > this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous slide
          this.previousSlide();
        } else {
          // Swipe left - go to next slide
          this.nextSlide();
        }
      }
    }

    // Utilities for media control
    pauseAllMediaExceptInSlide(slide) {
      const allowed = new Set(slide ? Array.from(slide.querySelectorAll('video-media, model-media')) : []);
      this.querySelectorAll('video-media[playing], model-media[playing]').forEach((el) => {
        if (!allowed.has(el)) {
          el.pause();
        }
      });
    }

    pauseNonActiveSlides() {
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.querySelectorAll('video-media[playing], model-media[playing]').forEach((element) => element.pause());
        }
      });
    }

    autoplayActiveSlideIfEligible() {
      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      const mediaEls = activeSlide.querySelectorAll('video-media, model-media');
      mediaEls.forEach((element) => {
        if (!element.hasAttribute('autoplay')) return;
        if (element.hasAttribute('playing')) return;
        // If already loaded, try immediately; else wait for 'loaded' attribute
        if (element.hasAttribute('loaded')) {
          element.play();
        } else {
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'loaded' && element.hasAttribute('loaded')) {
                observer.disconnect();
                element.play();
                break;
              }
            }
          });

          observer.observe(element, { attributes: true, attributeFilter: ['loaded'] });
        }
      });
    }
  }

  // Define the custom element
  customElements.define('media-gallery', MediaGalleryElement);
  } catch(e) { console.error(e); }
})();

})();
